import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8">
          漫画分类
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 text-center line-clamp-1">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}